<template>
  <header class="header" :class="{ 'header--on-top': isOnTop }">
    <h1>Let's Play</h1>
  </header>
</template>

<script src="./Header.js"></script>

<style scoped lang="scss" src="./Header.scss"></style>
